import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import CompanyInvestorMobile from './CompanyInvestorMobile'
import CompanyInvestorActivityMobile from './CompanyInvestorActivityMobile'

function CompanyInvestorMainMobile(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Invest with the best";
    const [param, setParam] = useState("cu");
    const { companyName } = useParams();
    
    const [companySymbol, setcompanySymbol] = useState('');
    if (companyName != companySymbol) {
        setcompanySymbol(companyName)
    }

    useEffect(() => {
    }, [])


    return (
        <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "9px", minHeight: "650px",paddingBottom: "40px", paddingTop: "10px" }}>
            <div style={{ padding: "5px" }}>
                <div className="CompanyNav" style={{ padding: "10px 0px 0px 0px", fontSize: "9px" }}>

                    <div className="CompanyMenu" id="current" onClick={() => {
                        setParam('cu')
                    }
                    } style={param === "cu" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Current</div>
                    <div className="CompanyMenu" id="Activity" onClick={() => {
                        setParam('ac')
                    }
                    } style={param === "ac" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Activity</div>
                    
                </div>
                <div style={{ padding: "10px 0px 0px 0px" }} >
                    {param === "cu" &&
                        <CompanyInvestorMobile companySymbol={companySymbol}/>
                    }
                    {param === "ac" &&
                        <CompanyInvestorActivityMobile companySymbol={companySymbol}/>
                    }
                </div>
            </div>
        </div>
    );
}
export default CompanyInvestorMainMobile;